export default function PHP_fseek() {
  return (
    <div>
      <h1>PHP_fseek</h1>
    </div>
  );
}
